// extracted by mini-css-extract-plugin
export var box = "_97-1";
export var checked = "_97-2";
export var descriptionSpacer = "_97-9";
export var disabled = "_97-3";
export var icon = "_97-6";
export var input = "_97-0";
export var labelSpacer = "_97-8";
export var medium = "_97-5";
export var small = "_97-4";
export var text = "_97-7";